<template>
  <div class="accordion_box">
    <div
      class="accordion_header"
      :class="activeClass"
    >
      <!-- S : 20220429 accordion_header_inner 추가, 결제예상금액 추가 -->
      <div class="accordion_header_inner">
        <p>구성된 마이 팩 by 뉴트리라이트</p>
        <div class="total_price pc">
          <p>결제예상금액: <em>{{ computedExpectedTotalPrice }}</em>원</p>
        </div>
      </div>
      <!-- E : 20220429 accordion_header_inner 추가, 결제예상금액 추가 -->
      <button
        type="button"
        class="btn_open"
        @click="isOpen = !isOpen"
      >
        자세히 보기
      </button>
    </div>
    <div class="accordion_content">
      <ul>
        <li
          v-for="product in products"
          :key="product.item_sku"
        >
          {{ product.item_name }}({{ product.count }}{{ product.display }})
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ComposedPackSection',
  props: {
    products: {
      type: Array,
      default: () => {},
    },
    expectedTotalPrice: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    activeClass() {
      return this.isOpen ? 'active' : '';
    },
    computedExpectedTotalPrice() {
      return this.expectedTotalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/composition/main/step2/ComposedPackSection.vue